// extracted by mini-css-extract-plugin
export default {"Overlay":"Modal_Overlay__qTvap","Modal":"Modal_Modal__7JuAJ","ButtonClose":"Modal_ButtonClose__Yo+2p","Header":"Modal_Header__RYFoR","ModalButtons":"Modal_ModalButtons__Xdq8u"};